function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  fill: "#32BA7C"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0AA06E",
  d: "M9 17.353l5.267 5.309C19.016 21.415 23 17.492 23 12.4v-.312L18.497 8 9 17.353z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M18.593 7.365l1.033.986a1.23 1.23 0 0 1 0 1.766l-6.695 6.362a1.196 1.196 0 0 1-.142.162l-1.032.985c-.499.476-1.353.476-1.852 0l-4.522-4.349a1.23 1.23 0 0 1 0-1.767l1.032-.985c.499-.476 1.354-.476 1.852 0l2.558 2.46 5.917-5.62c.498-.475 1.353-.475 1.851 0z"
}));

var SvgIcSuccess = function SvgIcSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_success.4f1654f6.svg";
export { ForwardRef as ReactComponent };